import { render, staticRenderFns } from "./CreateSite.vue?vue&type=template&id=1bf7ef8f&scoped=true"
import script from "./CreateSite.vue?vue&type=script&lang=js"
export * from "./CreateSite.vue?vue&type=script&lang=js"
import style0 from "./CreateSite.vue?vue&type=style&index=0&id=1bf7ef8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf7ef8f",
  null
  
)

export default component.exports